
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * SSLMode enum
 */
class SSLMode {
  /**
   * Initialize enum with a given value
   * @param {SSLMode|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof SSLMode) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!SSLMode}
   * @param {!SSLMode} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof SSLMode)) {
      throw new TypeError('Instance of SSLMode is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!SSLMode}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!SSLMode}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === SSLMode.NONE.value) {
      return 'NONE'
    }
    if (this.value === SSLMode.STARTTLS.value) {
      return 'STARTTLS'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!SSLMode}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!SSLMode}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!SSLMode} Created enum
   */
  static fromObject (other) {
    return new SSLMode(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
SSLMode.NONE = new SSLMode(0 + 0)
// noinspection PointlessArithmeticExpressionJS
SSLMode.STARTTLS = new SSLMode(0 + 1)

export { SSLMode };

/**
 * Fast Binary Encoding SSLMode field model
 */
class FieldModelSSLMode extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelSSLMode}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelSSLMode}
   * @param {SSLMode=} defaults Default value, defaults is new SSLMode()
   * @returns {!SSLMode} Result value
   */
  get (defaults = new SSLMode()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new SSLMode(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelSSLMode}
   * @param {!SSLMode} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelSSLMode };
